import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Program } from 'src/app/shared/models/programs';
import { CardsService } from 'src/app/shared/services/cards.service';
import { ProgramsService } from 'src/app/shared/services/programs.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class ProgramsComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  programsList: Program[] = [];
  programDetails: Program;

  constructor(
    private utilitiesService: UtilitiesService,
    private programsService: ProgramsService,
    private router: Router
  ) { }

  ngOnInit() {
   this._subscriptions.push(
      this.programsService.getPrograms().subscribe(programs =>{
        this.programsList = programs;
      })
    );
  }

  addProgram(){
    this.router.navigate(['/dash/program/']);
  }

  updateClient(id){
    this.router.navigate([`/dash/program/${id}`]);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }

}
